<div class="container landing-container primary-page-wrapper">
    <div class="page-head">
        <div class="head-inner-left">
            <div class="name-wrap">
                <h1 class="page-title">
                    Cotogna
                    <span class="status">open now</span>
                </h1>
                <button class="btn btn-outline-primary" title="Edit Details">Edit Details</button>
            </div>
            <div class="ul-wrap">
                <ul class="restro-info">
                    <li>Restaurant</li>
                    <li>Italian, Mediterranean</li>
                    <li>$34-$85</li>
                    <li>Top 20 places</li>
                </ul>
                <div class="btn-grps">
                    <a href="javascript: void(0);" title="Like">
                        <img src="./assets/images/ic-like.svg" alt="Icon">
                    </a>
                    <a href="javascript: void(0);" title="Share">
                        <img src="./assets/images/ic-share.svg" alt="Icon">
                    </a>
                </div>
            </div>
        </div>
        <div class="head-inner-right">
            <div class="ratings-wrap">
                <h5 class="rating-data">79 reviews</h5>
                <ngx-stars [readonly]="false" [size]="1" [color]="'#AE77A0'" [initialStars]="4.5"></ngx-stars>
            </div>
        </div>
    </div>

    <div class="nac-cta-outer">
        <div class="nav-cta-wrap">
            <div class="datepicker-grp">
                <input class="form-control datepicker-input" name="dp" [(ngModel)]="model" ngbDatepicker
                    #d="ngbDatepicker" (click)="d.toggle()" [value]="getFormattedDate(model)" autocomplete="off"
                    placeholder="Enter Date" />
                <img src="./assets/images/ic-arrow-down-dark.svg" alt="Icon" class="arrow">
            </div>
            <ng-select [(ngModel)]="timeSelect" class="ng-form-select custom time-select">
                <ng-option *ngFor="let time of times" [value]="time.id">{{time.name}}</ng-option>
            </ng-select>
            <ng-select [(ngModel)]="peopleSelect" class="ng-form-select custom people-select">
                <ng-option *ngFor="let people of peoples" [value]="people.id">{{people.name}}</ng-option>
            </ng-select>
            <button class="btn btn-primary" title="Find Table" ngbTooltip="Coming Soon" tooltipClass="tooltip-custom-root" placement="top">Find Table</button>
        </div>

        <div class="user-cmt d-none d-lg-flex">
            <h5 class="cmt"><span>Marecenas yr vitore</span></h5>
            <span class="img-block">
                <img src="./assets/images/user-profile.png" alt="Profile">
            </span>
        </div>
    </div>


    <div class="ui-gallery-wrap">
        <h1 class="block-title">Gallery</h1>
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li [ngbNavItem]="1">
                <button ngbNavLink>Restaurant</button>
                <ng-template ngbNavContent>
                    <div class="view-outer">
                        <div class="row row-cols-2 row-cols-md-4 row-cols-lg-5">

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-1.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-1.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-1.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-1.png" alt="Image">
                            </div>

                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="2">
                <button ngbNavLink>Food</button>
                <ng-template ngbNavContent>
                    <div class="view-outer">
                        <div class="row row-cols-2 row-cols-md-4 row-cols-lg-5">
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-1.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-4.png" alt="Image">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="3">
                <button ngbNavLink>Ambiance</button>
                <ng-template ngbNavContent>
                    <div class="view-outer">
                        <div class="row row-cols-2 row-cols-md-4 row-cols-lg-5">
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-1.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-2.png" alt="Image">
                            </div>
                            <div class="img-block">
                                <img src="./assets/images/slider-thumb-3.png" alt="Image">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
</div>